/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Mac_Step2Inputs */

const en_gc_resources_download_mac_step2 = /** @type {(inputs: Gc_Resources_Download_Mac_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag GridCraft into your Applications folder.`)
};

const zh_gc_resources_download_mac_step2 = /** @type {(inputs: Gc_Resources_Download_Mac_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 GridCraft 拖入“应用程序”文件夹。`)
};

/**
* | output |
* | --- |
* | "Drag GridCraft into your Applications folder." |
*
* @param {Gc_Resources_Download_Mac_Step2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_mac_step2 = /** @type {((inputs?: Gc_Resources_Download_Mac_Step2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Mac_Step2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_mac_step2(inputs)
	return zh_gc_resources_download_mac_step2(inputs)
});
export { gc_resources_download_mac_step2 as "gc.resources.download.mac.step2" }